import items from './items';
import users from './users';
import categories from './categories';
import config from './config';
import consumePackage from './consumePackage';
import locations from './locations';
import messages from './messages';
import monetizer from './monetizers';
import maps from './maps';
import loginModalState from './loginModalState';
import toastMessageState from './toastMessageState';
import fileManagerState from './fileManagerState';
import toggleFilters from './toggleFilters';
import toggleFiltersTanak from './toggleFiltersTanak';
import toggleUnreadNotifications from './toggleUnreadNotifications';
import toggleUnreadChats from './toggleUnreadChats';
import toggleSorting from './toggleSorting';
import toggleProfileCompletion from './toggleProfileCompletion';
import visualizationType from './visualizationType';
import track from './track';
import interventions from './interventions';
import interventionsData from './interventionsData';
import chat from './chat';
import sendIntervention from './sendIntervention';
import chatImagesData from './chatImagesData';
import resetLocation from './resetLocation';
import notifications from './notifications';
import notificationsPreferences from './notificationsPreferences';
import autocomplete from './autocomplete';
import chatServiceStatus from './chatServiceStatus';
import sitemap from './sitemap';
import seo from './seo';
import seoFooterLinks from './seoFooterLinks';
import seoPopularSearches from './seoPopularSearches';
import projects from './projects';
import user from './user';
import topSearches from './topSearches';
import filtersPreferences from './filtersPreferences';
import routeChange from './routeChange';
import addToHome from './addToHome';
import images from './images';
import leadFormConfig from './leadFormConfig';
import profileStatus from './profileStatus';
import cover from './cover';
import reviews from './reviews';
import reviewsRate from './reviewsRate';
import reviewsCounters from './reviewsCounters';
import navigationTree from './navigationTree';
import widgetConfig from './widgetConfig';
import hats from './hats';
import myads from './myads';
import posting from './posting';
import preNotification from './preNotification';
import bannerCMC from './bannerCMC';
import api from './api';
import leadDownloads from './leadDownloadQueue';
import canonicals from './canonicals';
import bundles from './bundles';
import locationOnboardingStatus from './locationOnboarding';
import filters from './filters';
import filtersAbundance from './filtersAbundance';
import campaigns from './campaigns';
import survey from './survey';
import serverContext from './serverContext';
import { OLXAutoReducer as olxAutos } from 'olx-autos-landing-page';
import bookAppointment from 'Autos/BookAppointmentV2/reducer';
import listingSlider from './listingSlider';
import inspectionConsent from './inspectionConsent';
import valuationFlow from 'Autos/ValuationFlow/reducer';
import vasSheet from './vasSheet';
import selfInspection from 'Autos/SelfInspection/reducer';
import financeConfig from './financeConfig';
import financeSetting from './financeSetting';
import olxAutosReducer from './olxAutos';
import meetings from './meetings';
import features from './features';
import adpv from './adpv';
import l2p from './l2p';
import myZone from './myzone';
import intentCtas from './intentCtas';
import isMyZoneEnabled from './myZoneFeatureFlags';
import reserve from './reserve';
import compareLayout from './compareLayout';
import compareCars from './compareCars';
import leadFormV2 from './leadFormV2';
import financeLayout from './financeLayout';
import faq from './faq';
import openInApp from './openInApp';
import dynamicContent from './dynamicContent';
import captureIntent from './captureIntent';
import partnership from './partnership';
import monetConfig from './monetRedesign';
import disclaimer from './disclaimer';
import sellerDashboard from './sellerDashboard';
import coupons from './coupons';
import categoriesWidget from './categoriesWidget';
import wishListTooltip from './wishListTooltip';

const reducers = {
    myads,
    items,
    users,
    categories,
    config,
    consumePackage,
    locations,
    messages,
    monetizer,
    maps,
    loginModalState,
    toastMessageState,
    fileManagerState,
    toggleFilters,
    toggleFiltersTanak,
    toggleUnreadNotifications,
    toggleUnreadChats,
    toggleSorting,
    toggleProfileCompletion,
    visualizationType,
    track,
    interventions,
    interventionsData,
    chat,
    sendIntervention,
    chatImagesData,
    resetLocation,
    notifications,
    notificationsPreferences,
    autocomplete,
    chatServiceStatus,
    sitemap,
    seo,
    seoFooterLinks,
    seoPopularSearches,
    projects,
    user,
    topSearches,
    filtersPreferences,
    routeChange,
    images,
    leadFormConfig,
    addToHome,
    profileStatus,
    cover,
    reviews,
    reviewsRate,
    reviewsCounters,
    navigationTree,
    hats,
    posting,
    preNotification,
    bannerCMC,
    api,
    leadDownloads,
    canonicals,
    bundles,
    locationOnboardingStatus,
    filters,
    filtersAbundance,
    campaigns,
    serverContext,
    ...olxAutos,
    survey,
    bookAppointment,
    listingSlider,
    inspectionConsent,
    valuationFlow,
    vasSheet,
    selfInspection,
    financeConfig,
    financeSetting,
    olxAutos: olxAutosReducer,
    meetings,
    features,
    adpv,
    widgetConfig,
    l2p,
    myZone,
    intentCtas,
    isMyZoneEnabled,
    reserve,
    compareLayout,
    compareCars,
    leadFormV2,
    financeLayout,
    faq,
    openInApp,
    dynamicContent,
    captureIntent,
    partnership,
    monetConfig,
    disclaimer,
    sellerDashboard,
    coupons,
    categoriesWidget,
    wishListTooltip
};

let orderedReducers = { ...reducers };

if (process.env.NODE_ENV !== 'production') {
    orderedReducers = {};

    Object.keys(reducers)
        .sort()
        .forEach(key => {
            orderedReducers[key] = reducers[key];
        });
}

export default orderedReducers;
